// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarMenuItem_menuItem__qVKn6 {
  height: 36px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #272A36;
  position: relative;
  border-radius: 12px;
  background: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  transition: 0.3s all;
  -webkit-user-select: none;
  -webkit-user-drag: none;
  -webkit-app-region: no-drag;
}
.SidebarMenuItem_menuItem__qVKn6:not(:last-child) {
  margin-bottom: 8px;
}
.SidebarMenuItem_menuItemDisabled__BjvEN {
  color: #c8cbde !important;
  pointer-events: none;
}
.SidebarMenuItem_menuItemDisabled__BjvEN .SidebarMenuItem_menuItem__icon__FF2Uu path {
  fill: #c8cbde;
  stroke: #c8cbde;
}
.SidebarMenuItem_menuItem__icon__FF2Uu, .SidebarMenuItem_menuItem__icon__FF2Uu path {
  transition: 0.2s all;
}
.SidebarMenuItem_menuItem__qVKn6:hover, .SidebarMenuItem_menuItemActive__iVaAn {
  color: #4778EE;
}
.SidebarMenuItem_menuItem__qVKn6:hover .SidebarMenuItem_menuItem__icon__FF2Uu path, .SidebarMenuItem_menuItemActive__iVaAn .SidebarMenuItem_menuItem__icon__FF2Uu path {
  fill: #4778EE !important;
}
.SidebarMenuItem_menuItemActive__iVaAn {
  background: #F0F4FE;
  color: #4778EE;
}
.SidebarMenuItem_menuItemActive__iVaAn:before {
  opacity: 1;
}
.SidebarMenuItem_menuItem__icon__FF2Uu {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  min-width: 36px;
  margin-left: 8px;
}
.SidebarMenuItem_menuItem__icon__FF2Uu path {
  fill: #272A36;
}
.SidebarMenuItem_menuItem__label__hn-FV {
  margin-left: 7px;
  text-decoration: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/HomeLayout/Sidebar/SidebarMenuItem/SidebarMenuItem.module.scss"],"names":[],"mappings":"AAEA;EACE,YAHO;EAIP,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EAEA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;AAFF;AAIE;EACE,kBAAA;AAFJ;AAKE;EACE,yBAAA;EACA,oBAAA;AAHJ;AAKI;EACE,aAAA;EACA,eAAA;AAHN;AAOE;EACE,oBAAA;AALJ;AAQE;EACE,cAAA;AANJ;AAQI;EACE,wBAAA;AANN;AAcE;EACE,mBAAA;EACA,cAAA;AAZJ;AAcI;EACE,UAAA;AAZN;AAgBE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YA/DK;EAgEL,WAhEK;EAiEL,eAjEK;EAkEL,gBAAA;AAdJ;AAgBI;EACE,aAAA;AAdN;AAkBE;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAhBJ","sourcesContent":["$height: 36px;\n\n.menuItem {\n  height: $height;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: #272A36;\n  position: relative;\n  border-radius: 12px;\n  background: white;\n\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  transition: 0.3s all;\n  -webkit-user-select: none;\n  -webkit-user-drag: none;\n  -webkit-app-region: no-drag;\n\n  &:not(:last-child) {\n    margin-bottom: 8px;\n  }\n\n  &Disabled {\n    color: #c8cbde !important;\n    pointer-events: none;\n\n    .menuItem__icon path {\n      fill: #c8cbde;\n      stroke: #c8cbde;\n    }\n  }\n\n  &__icon, &__icon path {\n    transition: 0.2s all;\n  }\n\n  &:hover, &Active {\n    color: #4778EE;\n\n    .menuItem__icon path {\n      fill: #4778EE !important;\n    }\n  }\n\n  //&:hover {\n  //  background: rgba(230, 230, 230, 0.6);\n  //}\n\n  &Active {\n    background: #F0F4FE;\n    color: #4778EE;\n\n    &:before {\n      opacity: 1;\n    }\n  }\n\n  &__icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    height: $height;\n    width: $height;\n    min-width: $height;\n    margin-left: 8px;\n\n    path {\n      fill: #272A36;\n    }\n  }\n\n  &__label {\n    margin-left: 7px;\n    text-decoration: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuItem": `SidebarMenuItem_menuItem__qVKn6`,
	"menuItemDisabled": `SidebarMenuItem_menuItemDisabled__BjvEN`,
	"menuItem__icon": `SidebarMenuItem_menuItem__icon__FF2Uu`,
	"menuItemActive": `SidebarMenuItem_menuItemActive__iVaAn`,
	"menuItem__label": `SidebarMenuItem_menuItem__label__hn-FV`
};
export default ___CSS_LOADER_EXPORT___;
